import { h, Fragment } from 'preact'
import { signal } from '@preact/signals'
import { isEmptyObject } from '../../js/modules/utilities.js'
import { attributesAnalytics } from '../../js/modules/component'

export const bandeOptionsEquipementState = signal('')

var recommendedOptions = {}
var installedOptions = {}

export const BandeOptionsEquipement = () => {
   let maxInstalledOptions = 3

   if (bandeOptionsEquipementState.value !== '' && bandeOptionsEquipementState.value['recommendedOptions'] !== undefined)
      recommendedOptions = bandeOptionsEquipementState.value['recommendedOptions'].recommendedOptions

   if (bandeOptionsEquipementState.value !== '' && bandeOptionsEquipementState.value['installedOptions'] !== undefined) {
      installedOptions = bandeOptionsEquipementState.value['installedOptions'].installedOptions
      // Combien d'options détenues max peuvent s'afficher ? Si info message présent alors 2, sinon 3
      maxInstalledOptions = isEmptyObject(installedOptions.infoMessage) ? 3 : 2
   }

   // Y a-t-il des options détenues remontées ?
   let hasInstalledOptions = !isEmptyObject(installedOptions)
   let hasRecommendedOptions = !isEmptyObject(recommendedOptions)

   return (
      <Fragment>
         {hasInstalledOptions || hasRecommendedOptions ? (
            <div class="bande-options-equipement bg-gray2 pt-3 pb-3 mb-3" data-testid="bande-options-equipements">
               <div class="container-fluid">
                  <div class="row">
                     {hasInstalledOptions ? <InstalledOptions {...installedOptions} maxInstalledOptions={maxInstalledOptions} /> : ''}
                     <div class={hasInstalledOptions ? 'col-12 col-xl-8' : 'noInstalledOptions col-12'}>
                        {hasRecommendedOptions ? <RecommendedOptions {...recommendedOptions} /> : ''}
                     </div>
                  </div>
               </div>
            </div>
         ) : (
            <PlaceHolder />
         )}
      </Fragment>
   )
}

const PlaceHolder = () => {
   return (
      <div class="bg-gray2 pt-3 pb-3 mb-3 isSkeleton">
         <div class="container-fluid">
            <div class="row">
               <div class="col-12 mb-2 col-xl-4 mb-xl-0">
                  <div id="options-detenues" class="bg-white h-100 px-1 px-sm-2 pt-1 pt-sm-2 pb-1">
                     <div class="ob1-skeleton-line ob1-skeleton-large mb-2"></div>

                     <div class="ob1-skeleton-line ob1-skeleton-large mb-2"></div>

                     <div class="ob1-skeleton-line ob1-skeleton-large mb-2"></div>

                     <div class="ob1-skeleton-line ob1-skeleton-large"></div>
                  </div>
               </div>
               <div class="col-12 col-xl-8">
                  <div id="options-recommandees" class="bg-white h-100 px-1 px-sm-2 pt-1 pt-sm-2 pb-1">
                     <div class="ob1-skeleton-line ob1-skeleton-large mb-2"></div>
                     <div class="row">
                        <div class="col-4">
                           <div class="ob1-skeleton-square ob1-skeleton-large"></div>
                        </div>
                        <div class="col-4">
                           <div class="ob1-skeleton-square ob1-skeleton-large"></div>
                        </div>
                        <div class="col-4">
                           <div class="ob1-skeleton-square ob1-skeleton-large"></div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

const InstalledOptions = ({ showAllOptions, infoMessage, options, title, maxInstalledOptions }) => {
   return (
      <div class="col-12 mb-2 col-xl-4 mb-xl-0">
         <div id="options-detenues" class="bg-white h-100 px-1 px-sm-2 pt-1 pt-sm-2 pb-1">
            <h2 class="no-signature mb-1">{title}</h2>
            <ul class="items-list row">
               {isEmptyObject(infoMessage) ? (
                  ''
               ) : (
                  <li class="col-12 col-md-6 col-xl-12 order-md-2 order-xl-0">
                     <div class="alert-container alert-container-sm alert-info mb-0" role="alert">
                        <p class="alert">
                           <span class="alert-icon" aria-hidden="true"></span>
                           <span class="ob1-alert-title">
                              <a
                                 href={infoMessage.URL}
                                 class="o-link-arrow ob1-link-dark p-0"
                                 {...attributesAnalytics(infoMessage.analytics)}
                              >
                                 {infoMessage.message}
                              </a>
                           </span>
                        </p>
                     </div>
                  </li>
               )}
               {options.slice(0, maxInstalledOptions).map((option, index) => {
                  return (
                     <li class={`col-12 col-md-6 col-xl-12 order-md-${index + 1}`}>
                        <a
                           href={option.URL}
                           class="items-list-item"
                           {...attributesAnalytics(option.analytics)}
                        >
                           <span class={`item-icon ${option.icon}`} aria-hidden="true"></span>
                           <div class="item-container">
                              <div class="item-text">
                                 <span>{option.name}</span>
                              </div>
                           </div>
                        </a>
                     </li>
                  )
               })}
               <li class="showAllOptions col-12 col-md-6 col-xl-12 order-md-4">
                  <a
                     href={showAllOptions.CTA.URL}
                     class="o-link-arrow mt-2 mt-md-1 mt-xl-1"
                     {...attributesAnalytics(showAllOptions.CTA.analytics)}
                  >
                     {showAllOptions.CTA.label}
                  </a>
               </li>
            </ul>
         </div>
      </div>
   )
}

const RecommendedOptions = ({ title, options, addOption }) => {
   return (
      <div id="options-recommandees" class="bg-white h-100 px-1 px-sm-2 pt-1 pt-sm-2 pb-1">
         <h2 class="no-signature mb-1">{title}</h2>
         <div class="row reco-options-list">
            {options.map((option) => {
               return (
                  <div class="col-4 reco-option">
                     <a
                        href={option.URL}
                        {...attributesAnalytics(option.analytics)}
                     >
                        <img class="w-100" src={`${option.image}?format=300x&saveas=webp`} alt={option.alt} loading="lazy" />
                     </a>
                  </div>
               )
            })}
         </div>
         <div class="row reco-add-option">
            <div class="col-12 mt-1 d-flex justify-content-center justify-content-md-end">
               <ul class="items-list">
                  <li>
                     <a
                        href={addOption.CTA.URL}
                        class="items-list-item"
                        {...attributesAnalytics(addOption.CTA.analytics)}
                     >
                        <span class="item-icon icon-modifier-add" aria-hidden="true"></span>
                        <div class="item-container border-0">
                           <div class="item-text">
                              <span>{addOption.CTA.label}</span>
                           </div>
                        </div>
                     </a>
                  </li>
               </ul>
            </div>
         </div>
      </div>
   )
}
